import React from 'react';
import FilterBarContainer from '../containers/FilterBarContainer';
import SelectedLetterContainer from '../containers/SelectedLetterContainer';

const Summary = () => (
  <>
    <FilterBarContainer />
    <h1>Summary</h1>
    <SelectedLetterContainer />
    <p>Magna cernantur doctrina te mandaremus quem ipsum senserit irure.</p>
    <p>Nam ipsum senserit an proident nam quis possumus.</p>
  </>
);

export default Summary;
